<template>
  <b-modal
    id="add-entreprise-modal"
    ref="modal"
    centered
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Validate')"
    :title="$t('Add.entreprise')"
    cancel-variant="outline-primary"
    @hidden="resetModal"
    @ok="handleOk"
    @show="resetModal">

    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        :invalid-feedback="entreprise.invalidFeedback"
        :label="$t('NewEntreprise')"
        :state="entreprise.state"
        label-for="entreprise-input">
        <b-form-input
          id="entreprise-input"
          v-model="entreprise.value"
          :state="entreprise.state"
          type="text"
          required>
        </b-form-input>
      </b-form-group>

    </form>
  </b-modal>
</template>

<script>
import api from '../../services/api'
import {bus} from "../../main";

export default {

  name: 'AddEntrepriseModal',
  props: {
    isFirstConnexion: {
      default: false
    }
  },

  data: function () {
    return {
      entreprise: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  methods: {

    resetModal() {
      this.entreprise.value = null
      this.entreprise.state = null
      this.entreprise.invalidFeedback = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('entreprise', this.entreprise.value.trim())

      api({
        method: 'POST',
        url: `/user/addEntreprise`,
        data: formData
      })
        .then(() => {
          this.successToast()
          bus.$emit("editProfile")
          bus.$emit("updateListEntreprises")
          this.resetModal()
          this.hideModal()
        })
        .catch(() => {
          this.errorToast()
        })
    },

    hideModal() {
      this.$bvModal.hide('add-entreprise-modal')
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }

      return true
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('AddEntreprise.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('AddEntreprise.error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/user/AddEntrepriseModal.vue